<template>
  <div class="main">
    <Scroll id="scrollContainer" loading-text="Loading...." :distance-to-edge="[-10,-10]" :on-reach-bottom="handleReachBottom" :height="carouselHeight + 50">
    <!-- <img class="logoImg" :src="logoPic"> -->
    <nav-header :years="years"></nav-header>
    <!-- 大图  dots="none"-->
    <Carousel v-model="carouselActive" loop>
      <CarouselItem v-for="(item, index) in carouselItems" :key="index">
        <!-- 视频(循环播放) -->
        <div v-if="isVideo(item.bannerUrl)" :style='{height: carouselHeight + "px",position:"relative"}' class="demo-carousel DivVideo">
          <video class="bannerVideo" :src="item.bannerUrl+'#t=0.1'" :controls="false" autoplay loop muted playsinline preload="auto"></video>
          <div class="mainInfos mainInfosV2" v-if="index == 0">
            <h1>Architizer <span>Visionary</span> 100</h1>
            <img class="logoImg" :style="{left: (carouselWidth*0.5) + 'px', opacity: 0.75}" :src="logoPic">
          </div>
        </div>

        <!-- 图片 -->
        <div v-else :style='{background:" url("+ item.bannerUrl +") no-repeat", height: carouselHeight + "px"}' class="demo-carousel DivImage">
          <div class="mainInfos" v-if="index == 0">
            <!-- <h1>{{years}} YEARS ARCHITECTURAL VISUALIZATION</h1> -->
            <h1>Architizer Visionary 100</h1>
            <img class="logoImg" :style="{left: (carouselWidth*0.5) + 'px', opacity: 0.75}" :src="logoPic">
          </div>
        </div>
      </CarouselItem>
    </Carousel>

    <!-- <swiper :options="swiperOption1">
      <swiper-slide v-for="(item, index) in carouselItems" :key="index">
        <div :style='{background:" url("+ item +") no-repeat", height: carouselHeight + "px"}' class="demo-carousel DivImage"></div>
      </swiper-slide>
    </swiper> -->

    <!-- pic group -->
    <div class="FTG-Menu imgNav">
      <Layout>
        <Header>
          <Menu mode="horizontal" theme="dark" active-name="all" @on-select="menuSelect">
            <div class="layout-nav SelectNone">
              <MenuItem name="all">All</MenuItem>
              <MenuItem name="4">Award</MenuItem>
              <MenuItem name="1">Still Image</MenuItem>
              <MenuItem name="2">Animation</MenuItem>
              <MenuItem name="3">VR | AR</MenuItem>
              <div class="Clear"></div>
            </div>
          </Menu>
        </Header>
      </Layout>
    </div>

    <!-- images -->
    <div v-show="false" class="ViewPic" v-viewer="{'title': false,'toolbar': false,'movable': false,'zoomable': false}">
      <img v-for="(list, index) in ViewPicLists" :key="list.photoId || index" :src="list.photoUrl">
    </div>
    
    <waterfall v-if="imageItems.length > 0 && imagesCol" :key="imagesCol" :col='imagesCol' :data="imageItems" :gutterWidth="10" class="image-box">
      <template>
        <div class="cell-item" v-for="(item,index) in imageItems" :key="item.galleryId || index" @click="onClickItem(item)">
          <!-- 
            v-lazy="item.coverUrl ? item.coverUrl : item.defaultUrl"
            ondragstart="return false" -->
          
          <!-- 图片类型 -->
          <template v-if="item.type == '0'">
            <img
              v-if="item.coverUrl"
              :style="{width: '100%'}"
              :src="item.coverUrl"
              ondragstart="return false"
            >
            <div class="item-body" :style="{color: '#000'}" v-if="item.coverUrl">
              <div class="item-desc">
                <p :style="{textOverflow: 'ellipsis',overflow: 'hidden',display: 'inline-block', width: '90%'}">
                  {{item.galleryName}} 
                </p>
                <span :style="{float: 'right', fontSize: '12px'}">{{item.photoNum}}<Icon :style="{marginLeft: '5px'}" type="md-albums" /></span>
              </div>
            </div>
          </template>

          <!-- 视频类型 -->
          <template v-if="item.type == '1'">
            <img
              v-if="item.coverUrl"
              :style="{width: '100%'}"
              :src="item.coverUrl"
              ondragstart="return false"
            >
            <div class="MainPlayBtn" >
              <svg t="1763819353924" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6466" width="32" height="32"><path d="M73.142857 0 910.957714 512 73.142857 1024Z" fill="#ffffff" p-id="6467"></path></svg>
            </div>
            <div class="item-body" :style="{color: '#000'}" v-if="item.coverUrl">
              <div class="item-desc">
                <p :style="{textOverflow: 'ellipsis',overflow: 'hidden',display: 'inline-block', width: '90%'}">
                  {{item.galleryName}} 
                </p>
                <span :style="{float: 'right', fontSize: '14px'}"><Icon :style="{marginLeft: '5px'}" type="ios-videocam" /></span>
              </div>
            </div>
          </template>
        </div>
      </template>
    </waterfall>

    <p v-if="isNoData" class="noMore">No more data...</p>
    

    <BackTop></BackTop>
    </Scroll>

    <!-- video Modal -->
    <div class="video-modal" v-if="videoModalVisible">
      <div class="closeBtn" @click="closeVideoModal">
        <Icon type="md-close" />
      </div>

      <div class="videoPlayBox">
        <video
          ref="videoPlayer"
          class="video-js vjs-default-skin vjs-big-play-centered"
          controls
          preload="auto"
          width="640"s
          height="360"
          data-setup="{}"
          :poster="videoPoster"
        >
          <source :src="videoSrc" tyxpe="video/mp4" />
          <p class="vjs-no-js">
            <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
          </p>
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from '../components/mainHeader.vue'
import logoPic from '../assets/image/FTG-logo.png'

import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
// import { swiper, swiperSlide } from 'vue-awesome-swiper'

import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  name: 'Main',
  components: {
    NavHeader,
    Swiper
  },
  // meta
  metaInfo: {
    title: 'FTG Studio',
    meta: [
      { name: 'description', content: 'Browse our complete portfolio of architectural visualization projects, covering architectural still rendering, exterior CGI visualization, interior rendering, architectural animation, urban masterplan visualization, campus building rendering, public commercial architecture visuals and residential architectural CGI artwork. Explore our finished high-end visual works to see our expertise in architectural rendering, lighting atmosphere crafting, material texture performance and architectural design presentation visualization.' }
    ]
  },
  data () {
    return {
      player: null,
      videoSrc: '',
      videoPoster: '',
      videoModalVisible: false,
      years: '',
      logoPic: logoPic,
      pageWidth: window.innerWidth,  // document.body.clientWidth
      imagesCol: 3,  // 默认3列，避免初始化时为null
      carouselActive: 0,
      carouselHeight: parseInt(window.innerHeight) - 50,
      carouselWidth: parseInt(window.innerWidth),
      // 首页大图
      carouselItems: [],

      // 加载图片
      isNoData: false,
      imageItems: [],
      count: 1,
      totalCount: null,
      typeActive: 'all',
      swiperOptions: {
        loop: true,
        observer: true,
        observeParents: true
      },
      ViewPicLists: []

    }
  },
  methods: {
    // 判断是否是视频
    isVideo(url){
      return url.indexOf('mp4') != -1 || url.indexOf('avi') != -1 || url.indexOf('mov') != -1
    },
    // 关闭视频弹窗
    closeVideoModal(){
      this.videoModalVisible = false
      this.videoSrc = ''
    },
    //改变type
    menuSelect(val){
      // console.log(val)
      this.typeActive = val
      this.count = 1  // 重置页码
      this.isNoData = false
      this.imageItems = []  // 先清空数组
      this.$nextTick(() => {
        this.getAlbumList()  // 在下一个 tick 中获取数据
      })
    },
    // 获取banner
    getBannerList(){
      const that = this
      let Data = {
        
      }
      that.$api.getBannerList(Data).then(res => {
        if(res.rescode == 0){
          if(Array.isArray(res.list) && res.list.length != 0){
            // '149.129.49.179' -> 'cdn.ftgstudio.com'
            // 'www.ftgstudio.com' -> 'cdn.ftgstudio.com'
            that.carouselItems = res.list.map(item => {
              item.bannerUrl = item.bannerUrl.replace('149.129.49.179', 'cdn.ftgstudio.com')
              item.bannerUrl = item.bannerUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')
              return item
            })
          }
        }else{
          that.$Message.error(res.msg);
        }
      }).catch(err => {});
    },
    initPlayer() {
      this.player = videojs(this.$refs.videoPlayer, {
        controls: true,
        autoplay: false,
        preload: 'auto',
        techOrder: ['html5'],
        sources: [{
          src: this.videoSrc,
          type: 'video/mp4'
        }]
      })
    },
    // 获取相册列表
    getAlbumList(){
      const that = this
      let Data = {
        pageNo: that.count,
        pageSize: 20
      }
      if(that.typeActive != 'all'){
        Data.galleryTypeId = parseInt(that.typeActive)
      }

      that.$api.getAlbumList(Data).then(res => {
        // console.log('获取到的相册列表 -> ', res)
        if(res.rescode == 0){
          // 直接赋值，让 Vue 重新渲染
          that.imageItems = res.list.map(item => {
            item.coverUrl = item.coverUrl.replace('149.129.49.179', 'cdn.ftgstudio.com')
            item.coverUrl = item.coverUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')
            item.defaultUrl = item.defaultUrl.replace('149.129.49.179', 'cdn.ftgstudio.com')
            item.defaultUrl = item.defaultUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')
            return item
          })
          that.totalCount = res.size
          if(that.imageItems.length == res.size){
            that.isNoData = true
          }else{
            that.isNoData = false
          }
        }else{
          that.$Message.error(res.msg);
        }
      }).catch(err => {});
    },
    // 返回图片列数
    getCol(_width){
      if(_width > 1100){
        return 3
      }else if(_width < 1100 && _width > 800){
        return 2
      }else {
        return 1
      }
    },
    onClickItem(item){
      if(item.type == '1'){
        this.videoSrc = item.videoUrl
        this.videoPoster = item.coverUrl
        this.videoModalVisible = true
        this.initPlayer()
      } else {
        this.addViewPics(item.galleryId)
      }
    },
    // 查看图片
    openImgView1(_index){
      const viewer = this.$el.querySelector('.imgViewer' + _index).$viewer
      viewer.show()
    },
    openImgView2(){
      const viewer = this.$el.querySelector('.ViewPic').$viewer
      viewer.show()
    },
    addViewPics(_id){
      const that = this
      let Data = {
        galleryId: _id
      }
      that.$api.getPicListAll(Data).then(res => {
        // console.log('获取相册下的图片 -> ', res)
        if(res.rescode == 0){
          that.ViewPicLists = res.list
          setTimeout(function(){
            that.openImgView2()
            var obj=document.querySelector('.viewer-container');
            obj.setAttribute('oncontextmenu','self.event.returnValue=false');
          },100)
        }else{
          that.$Message.error(res.msg);
        }
      }).catch(err => {});
      
    },
    // 加载更多
    handleReachBottom(){
      const that = this
      if(that.imageItems.length === that.totalCount){
        return false
      }
      return new Promise(resolve => {
        setTimeout(() => {
          that.count ++
          // 获取图片
          let Data = {
            pageNo: that.count,
            pageSize: 20
          }
          if(that.typeActive != 'all'){
            Data.galleryTypeId = parseInt(that.typeActive)
          }

          that.$api.getAlbumList(Data).then(res => {
            // console.log('下拉，获取到的相册列表 -> ', res)
            if(res.rescode == 0){
              for(let i=0;i<res.list.length;i++){
                res.list[i].coverUrl = res.list[i].coverUrl.replace('149.129.49.179', 'cdn.ftgstudio.com')
                res.list[i].defaultUrl = res.list[i].defaultUrl.replace('149.129.49.179', 'cdn.ftgstudio.com')
                res.list[i].coverUrl = res.list[i].coverUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')
                res.list[i].defaultUrl = res.list[i].defaultUrl.replace('www.ftgstudio.com', 'cdn.ftgstudio.com')
                that.imageItems.push(res.list[i])
              }
              that.totalCount = res.size

              if(that.imageItems.length == res.size){
                that.isNoData = true
              }else{
                that.isNoData = false
              }
            }else{
              that.$Message.error(res.msg);
            }
          }).catch(err => {});
          resolve();
        }, 2000);
      });
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  mounted() {
    const that = this

    eventBus.$on('alls', function () {
      that.typeActive = 'all'
      that.count = 1
      that.isNoData = false
      that.imageItems = []
      that.$nextTick(() => {
        that.getAlbumList()
      })
    });
    eventBus.$on('still', function () {
      that.typeActive = '1'
      that.count = 1
      that.isNoData = false
      that.imageItems = []
      that.$nextTick(() => {
        that.getAlbumList()
      })
    });
    eventBus.$on('animat', function () {
      that.typeActive = '2'
      that.count = 1
      that.isNoData = false
      that.imageItems = []
      that.$nextTick(() => {
        that.getAlbumList()
      })
    });
    eventBus.$on('arvr', function () {
      that.typeActive = '3'
      that.count = 1
      that.isNoData = false
      that.imageItems = []
      that.$nextTick(() => {
        that.getAlbumList()
      })
    });

    eventBus.$on('award', function () {
      that.typeActive = '4'
      that.count = 1
      that.isNoData = false
      that.imageItems = []
      that.$nextTick(() => {
        that.getAlbumList()
      })
    });


    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth;  //document.body.clientWidth
        that.pageWidth = window.screenWidth
      })()
    }
    that.imagesCol = that.getCol(window.innerWidth)  //document.body.clientWidth
  
    setTimeout(function(){
      new Swiper ('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          clickable :true
        },
        loop: false,
        observer: true,
        observeParents: true
      })
    }, 100)

    let date = new Date();
    const currentDate = date.getFullYear();
    this.years = currentDate - 2007 - 1
  },
  created(){
    const that = this
    that.getBannerList()
    that.getAlbumList()
  },
  watch: {
    pageWidth(val){
      if (!this.timer) {
        this.pageWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.imagesCol = that.getCol(val)
          that.timer = false
        }, 400)
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/css/main.less';
  .swiper-pagination {
    text-align: right;
  }
  .noMore {
    text-align: center;
    font-size: 12px;
    color: #888;
    padding: 10px 0;
  }
  .mainInfos {
    position: absolute;
    z-index: 999;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 153px;

    h1 {
      color: #fff;
      font-size: 46px;
      margin-bottom: 50px;
      text-align: center;
      font-weight: bolder;

      span {
        font-weight: 300;
      }
    }
  }

  .mainInfosV2 {
    width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      font-size: 65px;
      opacity: 0.8;
    }
  }
  .logoImg {
    width: 153px;
    display: block;
  }

  .bannerVideo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // 屏幕小于750px
  @media screen and (max-width: 750px) {
    .mainInfosV2 {
      width: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        font-size: 45px;
      }
    }
  }

  // 屏幕小于500px
  @media screen and (max-width: 500px) {
    .mainInfosV2 {
      width: 530px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        font-size: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main.vue